import _ from 'lodash';
import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        loaded: false,
    },
    getters: {
        categoryOptions(state) {
            return _.map(state.list, (category) => ({
                value: category.id,
                text: _.chain(category.name).values().first().value(),
            }));
        },
        restrictList(state, __, rootState) {
            return _.filter(state.list, ({ owner }) => {
                const isAdmin = rootState.auth.currentUser?.role === 'admin';
                return isAdmin || owner === rootState.auth.currentUser?.id;
            });
        },
    },
    actions: {
        preloadCategory({ state, dispatch }) {
            if (!state.loaded) {
                dispatch('fetch', { page: 1 }).then(() => {
                    state.loaded = true;
                });
            }
        },
        async fetch({ state }, { filter, query }) {
            const params = {
                filter,
                search: query,
            };
            const result = await Sdk.Category.PrivateList({ params });
            state.list = result.data.raw;
            state.total = result.data.total;
        },
        create(__, data) {
            const form = new Sdk.FormData(data);
            return Sdk.Category.PrivateCreateResource(form);
        },
        update(__, data) {
            const { id, ...payload } = data;
            const form = new Sdk.FormData(payload);
            return Sdk.Category.PrivateUpdateResource(id, form);
        },
        delete(__, data) {
            return Sdk.Category.PrivateDeleteResource(data.id);
        },
    },
};
